import React, { useCallback, useRef } from "react";
import { connect } from "react-redux";
import SearchAddressInputText from "./SearchAddressInputText";

const mapStateToProps = () => ({});

const mapDispatchToProps = () => ({});

const SearchAddressInputTextConnected = ({ mapInstance }) => {
  const markerInstance = useRef();

  const handleClose = useCallback(() => {
    if (markerInstance.current) {
      markerInstance.current.setMap(null);
    }
  }, [markerInstance]);

  return (
    <SearchAddressInputText
      mapInstance={mapInstance}
      handleClose={handleClose}
    />
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SearchAddressInputTextConnected);
